import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// Página pública, sin login (Fase 8 legal — Anexo A): el apoderado de un alumno de 16-17 años
// completa acá su consentimiento, a partir del enlace único que le llega por correo/WhatsApp
// (ver StudentGuardianConsentCard en staff/estudiantes.tsx). $token es el ID del doc en
// guardianConsents — alta entropía, es la única "autorización" que hace falta para leerlo (ver
// firestore.rules), nadie necesita ninguna cuenta de Firebase Auth para llegar hasta acá.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/consentimiento/$token",
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: lazyRouteComponent(() => import("./consentimiento-page"), "ConsentimientoPage"),
});
